<template>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5 2C3.3432 2 2 3.3432 2 5v14c0 1.6569 1.3432 3 3 3h14c1.6569 0 3-1.3431 3-3V5c0-1.6568-1.3431-3-3-3H5zm8.0039 10.6797l-.041-.0068v3.0693c1.2715-.0957 1.7637-.7178 1.7637-1.5039 0-.752-.3692-1.2305-1.7227-1.5586zm-2.4473-2.8438c0 .67.4102 1.1827 1.586 1.4766V8.4072c-1.0391.1368-1.586.7657-1.586 1.4287zm2.4063-1.4355v3.1103l.2119.0479c1.7568.4238 2.7412 1.1484 2.7412 2.584 0 1.6474-1.3398 2.5429-2.9531 2.666v1.1826h-.8203v-1.1894c-1.627-.1436-2.9736-1.1075-3.0215-2.7002h1.1894c.1231.8545.6495 1.5039 1.8321 1.6338v-3.2608l-.1572-.041c-1.7022-.4102-2.6182-1.169-2.6182-2.5156 0-1.4698 1.1553-2.4405 2.7754-2.584V6.1445h.8203v1.1826c1.5791.1436 2.8096 1.1417 2.8574 2.6524h-1.1894c-.0889-.9229-.7452-1.4629-1.668-1.5791z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "DollarIcon"
};
</script>
